import 'angular';
import * as _ from 'lodash-es';
import Features from '../../feature-manager/Features';
import AppConstants from '../../gorillaboy/AppConstants';
import { RootScope } from '../../types/angular-types';
import {GetTasksResponse, Task, Action} from '../../types/TaskTypes';
import TasksService from '../TasksService';

import './contact_admin_task.html';
import {IAuthenticatedUserService} from "../../types/ServiceTypes";
import SignalProvider from "../../gorillaboy/SignalProvider";

function ContactAdminTaskCtrl($scope: any,
                              $log: ng.ILogService, TasksService: TasksService,
                              authenticatedUser: IAuthenticatedUserService,
                              $translate: ng.translate.ITranslateService,
                              $q: ng.IQService,
                              MessageManager: any) {

    $log.info("ContactAdminTaskCtrl init");
    $scope.formData = {
        messageTxt : ''
    };
    $scope.createTaskBtnClicked = function () {
        TasksService.createTask(null, $scope.formData.messageTxt, null, AppConstants.TASKDEF_IDS.NOTIFY_ADMIN_TO_DO)
            .then(() => {
                MessageManager.addSuccessMessage($translate.instant('TASKS.CONTACT_ADMIN.SUCCESS_MSGS.CREATED_TASK'));
                $scope.$close();
            }, (error) => {
                MessageManager.addErrorMessage($translate.instant('TASKS.CONTACT_ADMIN.ERROR_MSGS.COULD_NOT_CREATE_TASK'));
                $scope.$dismiss();
            })
    };
}

ContactAdminTaskCtrl.$inject = ['$scope',
    '$log',
    'TasksService',
    'authenticatedUser',
    '$translate',
    '$q',
    'MessageManager'
];

angular.module('GorillaBoy.Tasks')
.controller('ContactAdminTaskCtrl', ContactAdminTaskCtrl);
